import { render, staticRenderFns } from "./LeadsDashboard.vue?vue&type=template&id=478a0ac8&"
import script from "./LeadsDashboard.vue?vue&type=script&lang=js&"
export * from "./LeadsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports